import type {
  HardwareCapabilities,
  HardwareResult,
  HardwareRuntimeAdapter,
} from "./contracts";

const browserCapabilities: HardwareCapabilities = {
  receiptPrinter: false,
  productionPrinter: false,
  cashDrawer: false,
  barcodeScanner: false,
  customerDisplay: false,
  paymentDevice: false,
};

export class BrowserFallbackHardwareAdapter implements HardwareRuntimeAdapter {
  readonly id = "BROWSER_FALLBACK";

  getCapabilities() {
    return browserCapabilities;
  }

  async printReceipt(_payload: unknown): Promise<HardwareResult> {
    return { ok: false, reason: "UNSUPPORTED", detail: "Receipt printer bridge not available" };
  }

  async openDrawer(_reason: string): Promise<HardwareResult> {
    return { ok: false, reason: "UNSUPPORTED", detail: "Cash drawer bridge not available" };
  }
}
